enum PerilNumber {
	NONE = 0,
	EARTHQUAKE = 1,
	FLOOD = 2,
	LANDSLIDE = 3,
}

export default PerilNumber;